// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;So teach us to number our days&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;that we may apply our hearts to wisdom.<br> </p> </div></div>";
// Exports
module.exports = code;